module.exports = __webpack_public_path__ + "img/3 polishing.f0848058.jpeg";